const availableOrgsQuery = `
  query GetAvailableOrgs($first: Int, $skip: Int, $where: OrganizzazioneWhereInput) {
    organizzaziones(first: $first, skip: $skip, where: $where, order: [nome_ASC]) {
      edges {
        node {
          objectId
          nome
          citta
          telefono1
          marketplace
        }
      }
      count
    }
  }
`
  .replace(/\r?\n|\r/g, "")
  .replace(/\t/g, " ");

export default availableOrgsQuery;
